var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<a ng-repeat=\"time in $ctrl.slots track by time.change_id\" ng-href=\"{{:: time.url }}\" rel=\"nofollow\">\n<oral-select-time-button class=\"col-xs-12\" time=\"time\" lang=\"{{ ::$ctrl.lang }}\" show-full-time=\"true\">\n</oral-select-time-button>\n</a>\n<div class=\"col-xs-12 show-more-times\">\n<normal-button icon=\"icon-plus\" link=\"{{ $ctrl.showMoreUrl }}\">\n<span translate>Näytä lisää vapaita aikoja</span>\n</normal-button>\n</div>\n";
var id1="app/next-times/next-times-times-container.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/next-times/next-times-times-container.tpl.html
// module id = 458
// module chunks = 0